





























































































































































































import masterdata, {
    ChildListElement,
    ListElement,
} from '@/services/masterdata';
import it from '@/translations/it';

export default {
    props: {
        lists: Object,
        filiale: String,
        filialiPAOProp: String,
        filialiFTLProp: String,
        filialiXTLProp: String,
        filialiLTLProp: String,
        moreAgentProp: Boolean,
        dateProp: Date,
        submitText: String,
        isdate: Boolean,
    },
    watch: {
        validate(this: any, newVal: any, oldVal: any) {
            this.checkAndEmit();
        },
    },
    data(this: any): any {
        const checkCustomerCareAgenti = (rule: any, value: string, callback: any) => {
            if (this.moreAgent && this.$refs[`filiali${rule.field.split('_')[1]}`].query !== '' && value == null) {
                callback(new Error(this.$t('masterDataFromRules.Required').toString()));
            }
            callback();
        };
        const checkCustomerCareFiliali = (rule: any, value: string, callback: any) => {
            if (this.moreAgent && this.$refs[rule.field].query === '') {
                callback(new Error(this.$t('masterDataFromRules.Required').toString()));
            }
            callback();
        };
        const checkCustomerCareAgent = (rule : any, value: string, callback: any) => {
            if (!this.moreAgent && this.Form.filiale !== '' && this.Form.customercare === '') {
                callback(new Error(this.$t('masterDataFromRules.Required').toString()));
            }
            callback();
        };
        const checkCustomerCareFiliale = (rule : any, value: string, callback: any) => {
            if (!this.moreAgent && this.Form.filiale === '') {
                callback(new Error(this.$t('masterDataFromRules.Required').toString()));
            }
            callback();
        };
        return {
            rules: {
                customercare_FTL: [
                    { validator: checkCustomerCareAgenti, trigger: ['blur', 'change'] },
                ],
                filialiFTL: [
                    { validator: checkCustomerCareFiliali, trigger: ['blur', 'change'] },
                ],
                customercare_LTL: [
                    { validator: checkCustomerCareAgenti, trigger: ['blur', 'change'] },
                ],
                filialiLTL: [
                    { validator: checkCustomerCareFiliali, trigger: ['blur', 'change'] },
                ],
                customercare_XTL: [
                    { validator: checkCustomerCareAgenti, trigger: ['blur', 'change'] },
                ],
                filialiXTL: [
                    { validator: checkCustomerCareFiliali, trigger: ['blur', 'change'] },
                ],
                customercare_PAO: [
                    { validator: checkCustomerCareAgenti, trigger: ['blur', 'change'] },
                ],
                filialiPAO: [
                    { validator: checkCustomerCareFiliali, trigger: ['blur', 'change'] },
                ],
                customercare: [
                    { validator: checkCustomerCareAgent, trigger: ['blur', 'change'] },
                ],
                filiale: [
                    { validator: checkCustomerCareFiliale, trigger: ['blur', 'change'] },
                ],
            },
            date: new Date(),
            moreAgent: false,
            filialiPAO: '',
            filialiFTL: '',
            filialiXTL: '',
            filialiLTL: '',
            Form: {
                customercare: '',
                customercare_FTL: '',
                customercare_LTL: '',
                customercare_XTL: '',
                customercare_PAO: '',
                filiale: '',
            },
            datepickerOptions: {
                disabledDate(time: Date) {
                    return time.getTime() < Date.now();
                },
            },
        };
    },
    methods: {
        computeAgenti(this: any, code: string) {
            if (this.lists.Agenti !== null) {
                return this.lists.Agenti.filter((i: ChildListElement) => i.ParentCode === code);
            }
            return null;
        },
        backStep(this: any) {
            this.$refs.form.clearValidate();
            this.emitData();
            this.$emit('back');
        },
        emitData(this: any) {
            this.$emit('customercare_FTL', this.Form.customercare_FTL);
            this.$emit('customercare_LTL', this.Form.customercare_LTL);
            this.$emit('customercare_XTL', this.Form.customercare_XTL);
            this.$emit('customercare_PAO', this.Form.customercare_PAO);
            this.$emit('customercare', this.Form.customercare);
            this.$emit('filiale', this.Form.filiale);
            this.$emit('filialiPAO', this.filialiPAO);
            this.$emit('filialiFTL', this.filialiFTL);
            this.$emit('filialiXTL', this.filialiXTL);
            this.$emit('filialiLTL', this.filialiLTL);
            this.$emit('moreAgent', this.moreAgent);
            this.$emit('date', this.date);
        },
        async nextStep(this: any) {
            this.emitData();
            this.$refs.form.validate((val: any) => {
                if (val) {
                    this.$emit('next');
                }
            });
        },
    },
    beforeMount(this: any) {
        this.Form.filiale = this.filiale;
        this.filialiPAO = this.filialiPAOProp;
        this.filialiFTL = this.filialiFTLProp;
        this.filialiXTL = this.filialiXTLProp;
        this.filialiLTL = this.filialiLTLProp;
        this.moreAgent = this.moreAgentProp;
        this.date = this.dateProp;
    },
};
